<template>
  <div id="past-banquet-dialog" class="ui modal">
    <div class="scrolling content">
      <div style="background-color:  red; color: #fff; padding: 15px; margin: -21px -21px 0 -21px;">
        <i class="fas fa-exclamation-triangle"></i> 重要なお知らせ
      </div>
      <div class="ui negative message">
        ご宴会実施日を過ぎている案件がございます。<br/>
        至急ステータスの更新操作及び、ご利用金額の入力をお願いします。<br/>
        <br/>
        案件操作方法については<a href="https://changeable-forgery-609.notion.site/1c92c84c9f83800bb7a6c0c9f7a41ebf" target="_blank" style="color: blue;">こちら</a>をご確認ください。
      </div>
      <table v-if="banquets.length > 0" class="ui compact table">
        <thead>
          <tr>
            <th>お問い合わせ番号</th>
            <th>チャット</th>
            <th>お名前（カナ）</th>
            <th>希望日時</th>
            <th>人数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="banquet in banquets" :key="banquet.id">
            <td>{{ banquet.marunage.code }}</td>
            <td>
              <a :href="banquet.chat_url" target="_blank">
                <i v-if="banquet.chat && banquet.chat.unread_count > 0" class="green large talk icon"></i>
                <i v-else class="large comment icon"></i>
              </a>
            </td>
            <td>{{ banquet.marunage.name_kana || banquet.marunage.name || '(未設定)' }}</td>
            <td>{{ banquet.marunage.event_date | formatDate }} {{ banquet.marunage.event_time }}</td>
            <td>{{ banquet.marunage.people_label }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="directCalls.length > 0" class="ui negative message">
        折り返し対応が必要な宴会予約の電話案件がございます。<br/>
        <a style="color: blue;" href="/shopadmin/banquets/direct_call?shop_status=initial">電話案件一覧</a>よりに記載の電話番号をご確認のうえ、速やかにご対応くださいますようお願いいたします。
      </div>
      <div class="ui positive message">
        操作に関してご不明点がある場合は、以下までご連絡ください。<br/>
        <br/>
        【グルメプラスサポート（株式会社オールフィット）】<br/>
        メールアドレス：info@gourmetplus.jp<br/>
        電話番号：0422-24-9496
      </div>
    </div>
    <div class="actions">
      <div class="ui button" @click="close">閉じる</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banquets: [],
      directCalls: []
    };
  },
  async created() {
    if (window.data.su) {
      return;
    }
    const banquets = await this.createForm().get('/shopadmin/api/banquets?billing_target=true');
    this.banquets = banquets.data.slice(0, 5);

    const directCalls = await this.createForm().get('/shopadmin/api/direct_calls?shop_status=initial');
    this.directCalls = directCalls.data;
    if (this.banquets.length > 0) {
      this.open();
    }
  },
  methods: {
    open() {
      $('#past-banquet-dialog').modal('show');
    },
    close() {
      $('#past-banquet-dialog').modal('hide');
    },
  }
};
</script>
